import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { SaveProcurementInvoiceRequest } from "@/main/models/request";
import { InvoiceFileResponse, InvoiceResponse } from "@/main/models/response";

export abstract class IInvoiceApi {
	abstract saveProcurementInvoice(request: SaveProcurementInvoiceRequest): Promise<AxiosResponse<Result<any>>>;
	abstract get(guidsProcurementSupplierItem: string[]): Promise<AxiosResponse<Result<InvoiceResponse[]>>>;

	abstract getinvoicefile(guidInvoice: string): Promise<AxiosResponse<Result<InvoiceFileResponse>>>;

	abstract getfilebyguidinvoicefile(guidInvoiceFile: string): Promise<AxiosResponse<Result<InvoiceFileResponse>>>;
}
